export default __webpack_public_path__ + "static/media/iphone2.61e8d022.png";